import React from "react";
import { FaServer, FaProjectDiagram, FaUsers, FaChartLine, FaLayerGroup, FaRobot } from "react-icons/fa";

function CryptoEScript() {
  const platforms = [
    { icon: <FaServer size={32} />, title: "Centralized Exchange (CEX)", desc: "Build an order-book based centralized exchange with high-speed matching engine and liquidity pools." },
    { icon: <FaProjectDiagram size={32} />, title: "Decentralized Exchange (DEX)", desc: "Launch an AMM or order-book DEX on any blockchain with smart contract-powered swaps." },
    { icon: <FaUsers size={32} />, title: "Peer-to-Peer Exchange", desc: "Enable direct crypto trading between users with built-in escrow and dispute resolution." },
    { icon: <FaChartLine size={32} />, title: "Derivatives Trading Exchange", desc: "Offer futures, options, and perpetual contracts with leverage up to 100x." },
    { icon: <FaLayerGroup size={32} />, title: "Margin Trading Exchange", desc: "Provide margin lending and borrowing pools with automated liquidation mechanisms." },
    { icon: <FaRobot size={32} />, title: "Automated Market Maker", desc: "Build liquidity pool-based exchanges with yield farming and LP token rewards." },
  ];

  return (
    <div style={{ padding: "80px 0", background: "#fff" }}>
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold" style={{ color: "#0a1f44", fontSize: "clamp(24px, 3vw, 38px)" }}>
            Our Crypto Exchange Platform Services
          </h2>
          <p className="text-muted mx-auto" style={{ maxWidth: "700px" }}>
            Xeer Technology offers a full spectrum of cryptocurrency exchange development services tailored to your business model and regulatory requirements.
          </p>
        </div>
        <div className="row g-4">
          {platforms.map((item, idx) => (
            <div className="col-lg-4 col-md-6" key={idx}>
              <div className="ce-platform-card">
                <div className="ce-platform-icon d-flex align-items-center justify-content-center">
                  {item.icon}
                </div>
                <h5 className="fw-bold mb-2" style={{ color: "#0a1f44", fontSize: "17px" }}>{item.title}</h5>
                <p className="mb-0 text-muted" style={{ fontSize: "14px", lineHeight: "1.6" }}>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CryptoEScript;
